import { Col, Container, Row } from "react-bootstrap";
import foto from "../assets/img/foto.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Banner = () => {
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeInLeft" : ""
                  }
                >

          

                  <span className="tagline">Welcome to my Portfolio!</span>
                  <h1>{`My name is Mariano Santos `}</h1>
                  <span>
                    FullStack Web Developer, UX/UI Designer, beginner game maker
                  </span>
                  <p>
                    I am a self-taught Full-Stack developer, I have been working
                    as a developer for 2 and a half years. I consider myself an
                    enthusiast of new technologies and logical thinking. I've
                    worked for private clients, and whenever I'm on a project
                    I'm looking to learn something new about the technology I'm
                    working with. My main objective is to continue learning
                    always motivated to reach the best version of myself.
                  </p>
                </div>
              )}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
            <img src={foto} alt="HeaderImg" className="my__foto" />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
